import { ActionTypes } from "../../constants/ActionTypes";
import { IConvertStatus } from "../../interfaces";

// convertStatus
export const onGetConvertStatus = (letterCode: string | undefined) => {
    return {
        payload: letterCode,
        type: ActionTypes.GET_CONVERTSTATUS,
    };
};

export const fetchConvertStatusSuccess = (convertStatus: IConvertStatus) => {
    return {
        type: ActionTypes.FETCH_CONVERTSTATUS_SUCCESS,
        payload: convertStatus,
    };
};
